import './index.scss'
import '../../assets/scripts/countNumber.js'
import Swiper from 'swiper/swiper-bundle.min.js'

function numScroll() {
  $(".number .num").each(function(){
    let num = $(this).attr('data-num')
    $(this).rollNum({
      deVal: num
    });
  })
}

$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度
  var contentH = $(document).height(); //内容高度

  // 数字滚动
  var rollNum = $('.section1 .cont1').offset().top - viewH

  if(scroH >= rollNum){
    numScroll()
  }else{
    $(".number .num").each(function(){
      let num = $(this).attr('data-num')
      $(this).html(num);
    })
  }
})

let swipers = $('.section1 .cont2 .item-swiper .swiper');
for(let i = 0; i < swipers.length; i++){
    new Swiper(swipers[i], {
      speed: 500,
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 20,
      slidesPerGroup: 1,
      breakpoints: { //响应式
        768: {  //当屏幕宽度大于等于768 
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 2
        },
        1280: {  //当屏幕宽度大于等于1280
          slidesPerView: 3,
          spaceBetween: 24,
          slidesPerGroup: 3
        }
      },
      navigation: {//按钮
        nextEl: $(swipers[i]).find('.swiper-button-next')[0],
        prevEl: $(swipers[i]).find('.swiper-button-prev')[0],
      },
      pagination: {// 分页
        el: $(swipers[i]).closest('.item-swiper').find('.swiper-pagination')[0],
        clickable: true,
      },
    });
}